<script>
  import { route } from "ziggy-js"
  import { getContext, onMount } from "svelte"
  import Link from "@components/Link.svelte"
  import CategoryList from "./CategoryList.svelte"
  import { categoryItemEventHandlerContextKey } from "@components/AppHeader/TheCategoryItem.svelte"
  import { AdUnitLocation } from "@shared/models/AdUnit/AdUnit"
  import AdUnitContainer from "@components/AdUnit/AdUnitContainer.svelte"
  import searchQueue from "@helpers/adUnitSearch"

  export let category

  const { handleBlur, handleClick } = getContext(categoryItemEventHandlerContextKey)

  $: adUnits = []

  onMount(async () => {
    adUnits = await searchQueue.push({
      location: AdUnitLocation.DesignerCategoryMenu,
      taxonomy_path: category.path,
    })
  })
</script>

<div
  class="mt-[2px] max-h-[60vh] lg:max-h-[calc(100vh-60px)] overflow-auto px-8 border shadow bg-canvas contrast-more:border-neutral-600"
>
  <div class="container mx-auto flex flex-col md:flex-row justify-between">
    <ul class="py-12 grid gap-8 md:gap-12 min-w-0 {category.classes}">
      {#each category.columns as column}
        {#each column as category}
          {@const routeParams = category.routeParams ? category.routeParams : { categories: [category.path] }}

          <li class="min-w-0 lg:min-w-[auto]">
            <Link
              href={route("merchant.products.index", routeParams)}
              on:click={handleClick}
              on:blur={handleBlur}
              class="text-2xl font-heading truncate block"
            >
              {category.name}
            </Link>

            {#if category.children}
              <CategoryList categories={category.children} />
            {/if}
          </li>
        {/each}
      {/each}
    </ul>

    <AdUnitContainer {adUnits} />
  </div>
</div>
